import { render, staticRenderFns } from "./DashboardAdminSumut.vue?vue&type=template&id=d39591bc&lang=pug"
import script from "./DashboardAdminSumut.vue?vue&type=script&lang=js"
export * from "./DashboardAdminSumut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports